import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { AppState } from 'shared/store/reducers';
import { setIsShowingChatUsageLimit } from 'shared/store/dashboard-slice';
import { LimitModal } from '../LimitModal';

export const ChatUsageWarningLimitModal: React.FC = () => {
  const dispatch = useDispatch();
  const { isShowingChatUsageLimit } = useSelector((state: AppState) => state.dashboard);

  // Reset modal state on unmount
  useEffect(() => {
    return () => void setIsShowingChatUsageLimit(false);
  }, []);

  const handleClose = useCallback(() => {
    dispatch(setIsShowingChatUsageLimit(false));
  }, [dispatch]);

  return (
    <LimitModal
      isVisible={isShowingChatUsageLimit}
      onClose={handleClose}
      title="New conversation limit reached"
      subtitle="You've reached the limit of new conversations during this period. Upgrade your plan to continue."
      closeText="No thanks"
    />
  );
};
